import GoogleMapsLoader from "google-maps";
import MarkerClusterer from "./markerclusterer";

const { language, mapsApiKey, assetsDir } = window.gage;
let scriptLoaded = false;

GoogleMapsLoader.VERSION = "weekly";

// Provide with wp_localize_script
GoogleMapsLoader.LANGUAGE = language;
GoogleMapsLoader.KEY = mapsApiKey;

function createMap(container = null) {
  let Gmap, Marker, InfoWindow;
  let markers, map;

  markers = [];

  const initializeMap = () => {
    const init = () => {
      map = new Gmap(container, {
        center: { lat: 60.9315, lng: 24.4094 },
        zoom: 8,
      });
    };

    // prevent additional loads
    if (!scriptLoaded) {
      GoogleMapsLoader.load(google => {
        Gmap = google.maps.Map;
        Marker = google.maps.Marker;
        InfoWindow = google.maps.InfoWindow;

        scriptLoaded = true;
        init();
      });
    } else {
      init();
    }
  };

  const updateMap = results => {
    if (!map) {
      console.log("Will not update a map that does not exist");

      return;
    }

    // Nuke current markers
    // https://developers.google.com/maps/documentation/javascript/examples/marker-remove
    markers.forEach(marker => marker.setMap(null));
    markers = [];

    const newMarkers = results.map(result => {
      const [oldLat, oldLng, pos, title, image, link] = [
        parseFloat(result.lat), // legacy value, new items use the pos field
        parseFloat(result.lng), // see above
        result.pos,
        result.title,
        result.image,
        result.link,
      ];

      const lat = pos ? pos.lat : oldLat;
      const lng = pos ? pos.lng : oldLng

      const marker = new Marker({
        position: {
          lat,
          lng,
        },
        map,
        title,
      });

      marker.addListener("click", () => {
        // InfoWindow must be created as late as possible, or it will load ALL
        // images in one go.
        const info = new InfoWindow({
          content: `
            <div class="artist-artwork-search__markerwindow">
              <a href="${link}" target="_blank" rel="noopener noreferrer">
                <h3>${title}</h3>
              </a>

              <img src="${image}" alt="${title}">
            </div>
          `,
        });

        info.open(map, marker);
      });

      return marker;
    });

    markers = newMarkers;

    // Can't do much about "side effects with new" with an external library
    // eslint-disable-next-line
    new MarkerClusterer(map, markers, {
      imagePath: assetsDir + "images/m",
    });
  };

  return {
    updateMap,
    initializeMap,
  };
}

export default createMap;
